import router from '@/router/'

export default {
  namespaced: true,
  actions: {
    moveToLogin() {
      router.push('/login').catch(() => {})
    },
  },
  modules: {},
}
